module.exports = __webpack_public_path__ + "static/media/Client.aacd2cb1.png";